<style lang="scss" scoped>
.dialog-choose-wrap {
  padding-bottom: 50px;
  overflow: hidden;

  .item-card {
    // width: 100%;
    margin-bottom: 10px;
    background-color: #fff;
    border: 1px solid $border-color-base;
    line-height: 60px;
    border-radius: 4px;
    padding-right: 16px;
    margin-right: 10px;
    cursor: pointer;
    user-select: none;
    // float: left;

    &:hover {
      background-color: $color-primary-light;
    }

    &:active {
      opacity: 0.8;
    }

    img {
      width: 40px;
      vertical-align: middle;
      margin-right: 10px;
      margin-left: 10px;
    }

    span {
      display: inline-block;
      // max-width: 100px;
    }
  }
}
</style>
<template>
  <el-dialog title="选择审批项"
    v-loading="pageLoading"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false" :close-on-press-escape="false"
    width="485px">
    <div class="dialog-choose-wrap">
      <div class="item-card" @click="chooseApprovalType(item.type)"
        v-for="item in tableList" :key="item.id">
        <img :src="`/api/base/static?file_path=${item.logo}`">
        <span>{{item.name}}</span>
      </div>
      <div v-if="!pageLoading && tableList && tableList.length <= 0"
        style="min-height: 100px; line-height: 100px;">
        暂无可发起的审批，请联系管理员开放权限
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getMyApprovals } from '@/api/approval'



export default {
  name: 'dialog-choose-approval',
  data() {
    return {
      dialogVisible: false,
      pageLoading: true,
      tableList: []
    }
  },
  components: {

  },
  mounted() {
    this.$on('open', () => {
      this.dialogVisible = true
      this.initPage()
    });
  },
  methods: {
    chooseApprovalType(typeId) {
      this.$emit('choose', typeId)
      this.dialogVisible = false
    },
    initPage() {
      this.pageLoading = true
      this.tableList = []
      getMyApprovals().then(res => {
        if (res.code != 0) throw new Error(res.message)
        this.tableList = res.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.pageLoading = false
      })
    }
  }
}
</script>
